import { useQuery } from '@tanstack/react-query';

import { ContractPackagePriceRequestMessage } from '../../../common/api/clients/packagePrice.api';
import { queries } from '../../../common/api/queryKeys/queries';

export function useContractPackagePrices(
    requestData: ContractPackagePriceRequestMessage[],
    deliveryDate: string | undefined,
    enabled: boolean
) {
    return useQuery({
        ...queries.packagePrices.contractPrices(requestData, deliveryDate),
        enabled: enabled && requestData.length > 0,
    });
}
